import { getDateNow } from "@/App/utils/dateNow";

export const getDateDaysAgo = (daysAgo: number): string => {
  const d = getDateNow();
  d.setDate(d.getDate() - daysAgo);
  return d.toISOString();
};
